/**
 * To enable the view use data-view="form". Please note that the form view needs to have is root on a form element.
 * example:
 * <form class="component" data-view="form"></form>
 */
(function (ws) {
    'use strict';
    ws.views.newUserForm = ws.views.form.extend({

        mainError: '.form-main-error',

        /**
         * Additional field validations
         */
        additionalValidation: function() {
            this.checkEmail();
            this.pwdLengthCheck();
        },

        /**
         * Password length check
         */
        pwdLengthCheck: function() {
            var $pwdField = this.$('input.password');
            var password;
            var _this = this;

            _.each($pwdField, function(field) {
                password = $(field).val();
                if (password.length < 5) {
                    _this.error = true;
                    $(field).addClass(_this.errorClass);
                }
            });
        },

        /**
         * Override default error function
         */
        hasError: function() {
            $(this.mainError).show();
        }

    });
})(westcon);
